.dealer {
    margin-top: 40px;
}

.name {
    margin-bottom: 10px;
    font-size: 30px;
    font-weight: 600;
}